import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import SilverBadge from '../components/SilverBadge';

const PaymentSuccess: React.FC = () => {
  const { isAuthenticated, user, updateUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const refresh = async () => {
      if (!isAuthenticated) return;
      try {
        setLoading(true);
        const response = await authAPI.getCurrentUser();
        updateUser(response.user || {});
      } catch (err: any) {
        setError(err?.response?.data?.error || err?.message || 'Unable to refresh account status.');
      } finally {
        setLoading(false);
      }
    };
    refresh();
  }, [isAuthenticated]);

  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '760px', margin: '40px auto' }}>
        <span className="badge green">Payment Successful</span>
        <h1 className="h1" style={{ marginTop: '10px' }}>Your payment is confirmed</h1>
        <p className="muted">
          Your subscription has been activated. You can continue using the platform with updated plan benefits.
        </p>
        {loading && <p className="muted">Refreshing your account status...</p>}
        {error && <div className="alert alert-error">{error}</div>}

        {user && (
          <p style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <strong>{user.full_name || user.email}</strong>
            <SilverBadge user={user} />
          </p>
        )}

        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '14px' }}>
          <Link className="btn" to={user?.role === 'candidate' ? '/candidate/dashboard' : user?.role === 'recruiter' ? '/recruiter/dashboard' : '/'}>
            Continue
          </Link>
          <Link className="btn ghost" to="/pricing">Back to Pricing</Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
